import { Component, OnInit } from '@angular/core'
import { AbstractControl, FormControl, FormGroup, Validators } from "@angular/forms"
import { ActivatedRoute } from '@angular/router'
import { NotificationService } from "../../../../../../notification/shared/notification.service"
import { BasketService } from "../../../../../basket/shared/basket.service"
import { Porteur } from "../../../shared/porteur"

@Component({
  selector: 'app-fonction',
  templateUrl: './fonction.component.html',
  styleUrls: ['./fonction.component.scss']
})
export class FonctionComponent implements OnInit {
  porteur: Porteur;
  identityForm: FormGroup = new FormGroup({
    'function': new FormControl('', [
      Validators.required
    ])
  })
  constructor(private route: ActivatedRoute,
    private basketService: BasketService,
    private notificationService: NotificationService) { }

  ngOnInit() {
    this.route.parent.data.subscribe(data => {
      this.porteur = data.porteur
    })
  }

  get function(): AbstractControl {
    return this.identityForm.get('function');
  }

  submitForm() {
    if (null !== this.porteur && this.identityForm.valid) {
      this.basketService.addBasketLine({
        type: "CHANGEMENT DE FONCTION",
        numPorteur: this.porteur.numPorteur,
        function: this.identityForm.get('function').value,
        codeService: this.porteur.codeService,
      }).subscribe(res => this.success())
    }
  }

  success() {
    this.notificationService.notif("Votre demande de modification de nom et de fonction a été ajoutée au panier. Elle sera automatiquement supprimée sous 2 jours si elle n'est pas validée.", "notif");
  }

}
